@if (tab) {
  @if (isCreationTab(tab)) {
    <lib-creation-personne-morale-dashboard
      [columnSelection]="tab.columnSelection"
      [config]="tab.dashboardConfiguration"
      (onTotalCount)="tab.updateLabel($event)"
      (onDeclareSouscription)="onDeclareSouscriptionFromCreationPM($event)">
    </lib-creation-personne-morale-dashboard>
  }
  @if (isOperationTab(tab)) {
    <app-operation-dashboard
      [columnSelection]="tab.columnSelection"
      [filterSelection]="tab.filterSelection"
      [defaultQueryFilter]="tab.defaultQueryFilter"
      (onTotalCount)="tab.updateLabel($event)"
      [withSelects]="true"
      [showCheckbox]="canConsultantSelectOperationToTerminate"
      [allowedActions]="allowedActions"
      [refreshFromNetworkOnLoad]="refreshFromNetworkOnLoad"
      (onSelectedOperation)="onOperationClick($event)"
      [dashboardKey]="tab.dashboardKey"></app-operation-dashboard>
  }
}
